import React from 'react';
import { CodeblockFlexItem } from './Codeblock';
import { flexChildPropsObj } from '../constants/flexboxProps';


const FlexItemPanel = ({ itemId, itemProps, dispatch }) => {

  let { order, flexGrow, flexShrink, flexBasis, alignSelf } = itemProps;

  return (
    <div className="flex-item-panel">
      <button 
        className="btn bg-warning"
        onClick={() => dispatch({
          type: 'FLEX-ITEM-PROP-RESET',
          payload: {
            itemId
          }
        })}
      >R</button>


      <div className="flex-item-title">Flex_Item_{itemId + 1}</div>

      <div className="py-2">
        <span className="property-name pr-1">Order : </span>
        <span>
          <input
            type="number" className="custom-input"
            value={order}
            onChange={(e) => {
              dispatch({
                type: 'order',
                payload: {
                  itemId,
                  value: e.target.value
                }
              })
            }}
          />
        </span>
      </div>

      <div className="flex-grow">
        <span className="property-name ">Flex : </span>
        <span className="p-relative">

          <input
            type="number" className="custom-input"
            value={flexGrow}
            onChange={(e) => {
              dispatch({
                type: 'flexGrow',
                payload: {
                  itemId,
                  value: e.target.value
                }
              })
            }}
          />

          <span className="flex-gr-prop">flex-grow</span>
           |
        </span>
        <span className="p-relative">

          <input
            type="number" className="custom-input"
            value={flexShrink}
            onChange={(e) => {
              dispatch({
                type: 'flexShrink',
                payload: {
                  itemId,
                  value: e.target.value
                }
              })
            }}
          />

          <span className="flex-gr-prop">flex-shrink</span>
          |
        </span>
        <span className="p-relative">
          <input
            type="text" className="custom-input"
            value={flexBasis}
            onChange={(e) => {
              dispatch({
                type: 'flexBasis',
                payload: {
                  itemId,
                  value: e.target.value
                }
              })
            }}
          />

          <span className="flex-gr-prop">flex-basis</span>;
        </span>
      </div>

      <div className="pb-1">

        <CodeblockFlexItem
          cssProp={flexChildPropsObj.alignSelf}
          dispatch={dispatch}
          currentValueSelect={alignSelf}
          itemId={itemId}
        />

      </div>

    </div>
  );
}

export default FlexItemPanel;